module.exports = __webpack_public_path__ + "static/media/21ECLAC8.d21a0f14.jpg";